<template>
  <section id="solutionsOfferedSection" class="solutions-offered-section">
    <b-container>
      <b-row>
        <b-col sn="12" md="8" lg="8" order="2" order-md="1">
          <div class="section-content">
            <h2 class="title-section">{{$t('solutions_offered_title')}}</h2>
            <!--<p class="solutions-content-text" v-html="$t('solutions_text_1')"></p>-->
          </div>
        </b-col>
        <b-col sm="12" md="4" lg="4" order="1" order-md="2">
          <div class="section-img">
            <img class="section-images" src="../assets/img/animations.svg" alt="Image">
          </div>
        </b-col>
      </b-row>
      <b-row class="margin-t-40 stretch" >
        <b-col class="card-column" sm="12" md="12" lg="4" v-for="(item, index) in cards" :key="index">
          <div class="solutions-card-info-container">
            <div class="header-card" v-html="$t(item.title)"></div>
            <div class="content-card" v-html="$t(item.content)"></div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  data () {
    return {
      cards: [
        {
          title: 'solutions_title_card_1',
          content: 'solutions_content_card_1'
        },
        {
          title: 'solutions_title_card_2',
          content: 'solutions_content_card_2'
        },
        {
          title: 'solutions_title_card_3',
          content: 'solutions_content_card_3'
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/sass/app.scss";
.solutions-offered-section{
  padding-top: 80px;
  padding-bottom: 48px;
  background: #ffffff;
  .section-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    .solutions-content-text{
      color: #30394B;
      font-family: $main-font;
      font-size: 20px;
      font-style: normal;
      font-weight: 300;
      line-height: 140%;
      margin: 0;
      @media screen and (min-width: 320px) {
        font-size: 18px;
      }
      @media screen and (min-width: 768px) {
        font-size: 16px;
      }
      @media screen and (min-width: 992px) {
        font-size: 20px;
      }
      @media screen and (min-width: 1440px) {
      }
      @media screen and (min-width: 1920px) {
      }
    }
  }
  .section-img {
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (min-width: 320px) {
      margin-bottom: 40px;
    }
    @media screen and (min-width: 768px) {
      margin-bottom: 0;
    }
    @media screen and (min-width: 992px) {
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
  }
  .card-column{
    margin-bottom: 32px;
  }
  .solutions-card-info-container{
    height: 100%;
    background: #ffffff;
    border-radius: 24px;
    box-shadow: 0px 6.336px 15.84px 0px rgba(41, 76, 96, 0.20);
    .header-card{
      min-height: 101px;
      padding: 24px;
      color: #30394B;
      font-family: $main-font;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 28px;
      background: #90F4A1;
      border-radius: 24px 24px 0px 0px;
    }
    .content-card{
      padding: 24px;
      color: #30394B;
      font-family: $main-font;
      font-size: 16px;
      font-style: normal;
      font-weight: 300;
      line-height: 22px;
    }
  }
}
</style>
